import { getStorebrandClient } from "Api/clients/storebrand";
import { BonusOption } from "./";

const BASE_URL = "/open/insurance/registry";

export async function getAutoBonusOptions(): Promise<BonusOption[]> {
  const productPath = "private";
  const url = `${BASE_URL}/bonus/${productPath}`;
  const client = await getStorebrandClient();
  const response = await client.get<BonusOption[]>(url);

  return response.data ? response.data.reverse() : [];
}
